import NavLink from "./NavLink";
import { isActive } from "./utils";
import React, { useState } from "react";
import classNames from "classnames";
import { Portal } from "react-portal";
import { usePopper } from "react-popper";
import useSubNav from "./useSubNav";
import Icon, { iconName } from "../../shared/icons/Icon";

type NavSubProps = {
  // Path, title, permission, new, metricsCategory, metricsSubCategory
  items: [string[], string, boolean | undefined, boolean?, string?, string?][];
  title: string;
  icon: iconName;
};

const SubNav = ({ items, title, icon }: NavSubProps) => {
  const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "right-start",
  });

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [open, setOpen] = useSubNav();
  const activeNavSub = items.reduce((accumulator, currentValue) => {
    return isActive(currentValue[0]) ? true : accumulator;
  }, false);

  let timer: number;

  const closePopover = () => {
    if (popoverOpen) {
      timer = setTimeout(() => {
        setPopoverOpen(false);
      }, 200);
    }
  };

  const openPopover = () => {
    if (popoverOpen) {
      clearTimeout(timer);
    } else {
      setPopoverOpen(true);
    }
  };

  const renderedItems = items.map((item) => (
    <NavLink
      key={item[0][0]}
      to={item[0]}
      show={item[2]}
      metricsCategory={item[4]}
      metricsSubCategory={item[5]}
    >
      <span>{item[1]}</span>
      {/* Show a yellow sparkle for new items */}
      {item[3] && <Icon icon="sparkles" className="right text-yellow" />}
    </NavLink>
  ));
  if (!items.some((e) => e.includes(true))) return null;
  return (
    <li>
      <div onMouseLeave={closePopover} onMouseEnter={openPopover}>
        <div
          ref={setReferenceElement}
          className={classNames("nav-sub-item portal", { active: activeNavSub })}
        >
          <Icon icon={icon} size={"fa-lg"} />
          <span>{title}</span>
        </div>
        {popoverOpen && (
          <Portal>
            <div
              className="asidePortal"
              onClick={() => setPopoverOpen(false)}
              ref={setPopperElement}
              style={styles.popper}
              {...attributes.popper}
            >
              <ul className="nav-sub">{renderedItems}</ul>
            </div>
          </Portal>
        )}
      </div>
      <div
        className={classNames("nav-sub-item", { active: activeNavSub })}
        onClick={() => setOpen(open !== title ? title : false)}
      >
        <Icon icon={icon} size={"fa-lg"} />
        <span>{title}</span>
        <i
          className={classNames("far fa-chevron-down right", {
            "fa-flip-vertical": open === title,
          })}
        />
      </div>
      {open === title && <ul className={"nav-sub collapse show"}>{renderedItems}</ul>}
    </li>
  );
};

export default SubNav;
